/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-boolean-value */
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { Link } from 'react-router-dom';
import { Stack, Button, Box } from '@mui/material';
import CTabPanel, { a11yProps, CTab, CTabs } from 'components/reusable/CTabPanel';
import Table from './Table';
import Filters from 'components/common/Filters';
import { getFilterValues } from 'components/PreferenceFilter';
import { useGetLocationsQuery } from 'store/services/patient';
import useAuth from 'hooks/useAuth';
import { PatientDropdown } from 'components/reusable/Dropdowns';
import usePermission from 'hooks/usePermission';
import { useGetTherapistListQuery } from 'store/services/therapy';
import { SERVICE_PSYCHOLOGICAL_TESTING } from 'constant';
import { useGetPsychologicalTherapistListQuery } from 'store/services/pshychologicalAssessment';
import { useAssessmentForm } from './useAssessmentForm';

const initialFilters = [
    {
        id: 'locations',
        label: 'Locations',
        type: 'checkbox',
        multiple: true,
        options: [],
        default: []
    },
    {
        id: 'therapists',
        label: 'Employees',
        type: 'checkbox',
        multiple: true,
        options: [],
        default: []
    }
];

const List = () => {
    const { hasPermission } = usePermission();

    const [disableFilter, setDisableFilter] = useState(false);

    const [activeTab, setActiveTab] = useState(0);
    const [filters, setFilters] = useState(initialFilters);
    const [filterValues, setFilterValues] = useState(getFilterValues(initialFilters));
    const { user } = useAuth();
    const [patient, setPatient] = useState(null);
    const [page, setPage] = useState(1);
    const handleChange = (_e, newValue) => {
        setPage(1);
        setActiveTab(newValue);
    };

    const onFilterChange = (value) => {
        setPage(1);
        setFilterValues(value);
    };

    const { data: locationList, isFetching: locationLoading } = useGetLocationsQuery({
        filters: {
            ...(user?.client_id && { client_id: user.client_id }),
            order_col: 'name',
            order: 'asc'
        }
    });

    useEffect(() => {
        if (locationList) {
            setFilters((prev) => {
                const newFilters = [...prev];
                const locationFilter = newFilters.find((item) => item.id === 'locations');
                locationFilter.options = locationList.fields.map((item) => ({
                    id: item.id,
                    name: item.name,
                    isActive: item?.is_active
                }));
                return newFilters;
            });
        }
    }, [locationList]);

    const { data: therapistList, isFetching: therapyLoading } = useGetPsychologicalTherapistListQuery({
        filters: {
            ...(user?.client_id && { clients: [user.client_id] }),
            services: [SERVICE_PSYCHOLOGICAL_TESTING],
            source: 'psychological-testing',
            // locations: filterValues.locations,
            order_col: 'name',
            order: 'asc'
        }
    });

    useEffect(() => {
        if (therapistList) {
            setFilters((prev) => {
                const newFilters = [...prev];
                const therapistFilter = newFilters.find((item) => item.id === 'therapists');
                therapistFilter.options = therapistList.fields.map((item) => ({
                    id: item.emp_id,
                    name: item.name
                }));
                return newFilters;
            });
        }
    }, [therapistList]);

    return (
        <MainCard
            title="Psychological Testing"
            content={false}
            secondary={
                <Stack direction="row" sx={{
                    alignItems: "center"
                }}>
                    <PatientDropdown
                        disabled={disableFilter}
                        loading={locationLoading}
                        async
                        size="small"
                        sx={{ width: 240 }}
                        value={patient}
                        isLimitSearch
                        onChange={(value) => {
                            setPage(1);
                            setPatient(value);
                        }}
                    />
                    <Filters.Root dateRageKeys={['startDate', 'endDate']} value={filterValues} filters={filters} onChange={onFilterChange}>
                        <Filters.Datepicker sx={{ my: 2 }} label="From Date" id="startDate" />
                        <Filters.Datepicker label="To Date" id="endDate" />
                    </Filters.Root>

                    {hasPermission(['psychological_testing_add']) && (
                        <Button color="primary" variant="contained" component={Link} to="/psychologicaltesting/add">
                            Add Psychological Testing
                        </Button>
                    )}
                </Stack>
            }
        >
            <Box sx={{
                p: 2
            }}>
                <CTabs value={activeTab} onChange={handleChange}>
                    <CTab label="In Progress" {...a11yProps(0)} />
                    <CTab label="Signed" {...a11yProps(1)} />
                </CTabs>

                <CTabPanel value={activeTab} index={0}>
                    <Table
                        parent="in_progress"
                        patient={patient}
                        filterValues={filterValues}
                        setDisableFilter={setDisableFilter}
                        setPage={setPage}
                        page={page}
                    />
                </CTabPanel>

                <CTabPanel value={activeTab} index={1}>
                    <Table
                        parent="completed"
                        patient={patient}
                        filterValues={filterValues}
                        setDisableFilter={setDisableFilter}
                        setPage={setPage}
                        page={page}
                    />
                </CTabPanel>
            </Box>
        </MainCard>
    );
};

export default List;
